





































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Card from '@/modules/shared/components/shared/Card.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { AdminNoteGetNotesUseCase } from '@/modules/common/note/use-cases/admin-note-get-notes.use-case'
import { NoteCollectionModel } from '@/modules/common/note/models/note-collection.model'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { NoteRequestModel } from '@/modules/common/note/models/note-request.model'
import { AdminNoteStoreUseCase } from '@/modules/common/note/use-cases/admin-note-store.use-case'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import { AdminNoteService } from '@/modules/common/note/services/admin-note.service'
import { AdminNoteUpdateUseCase } from '@/modules/common/note/use-cases/admin-note-update.use-case'

@Component({
  components: { AdminUserInfoButton, DateTooltipped, BaseInput, Modal, BaseButton, Card, BaseCard }
})
export default class NoteCommentsViewer extends Vue {
  constructor(
    private readonly getNotesUseCase: AdminNoteGetNotesUseCase,
    private readonly noteStoreUseCase: AdminNoteStoreUseCase,
    private readonly noteUpdateUseCase: AdminNoteUpdateUseCase,
    private readonly noteService: AdminNoteService
  ) {
    super()
  }

  @Prop({ required: true }) modelType!: string
  @Prop({ required: true }) modelId!: number
  @Prop({ default: false }) triggerAddComment!: boolean
  expand: boolean = false
  modal = this.triggerAddComment
  notes: NoteCollectionModel[] = []
  updateNoteId: number = null
  moreArr: boolean[] = []

  storeRequest: NoteRequestModel = {
    message: '',
    model_type: this.modelType,
    model_id: this.modelId
  }

  mounted() {
    this.getNotes()
  }

  @Watch('triggerAddComment')
  onTrigger(newVal) {
    this.storeRequest.message = ''
    this.modal = newVal
  }

  getNotes() {
    const promise = this.getNotesUseCase.execute(this.modelId, this.modelType)
    promise.on('success', () => {
      this.notes = this.getNotesUseCase.data
      this.moreArr = new Array(this.notes.length).fill(false)
    })
  }

  get hasNotes() {
    this.$emit('has-notes', this.notes.length > 0)
    return (this.notes.length > 0)
  }

  onHide() {
    this.$emit('has-notes', this.notes.length > 0)
  }

  onSubmit() {
    if (this.updateNoteId) this.onUpdateSubmit()
    else this.onStoreSubmit()
  }

  onStoreSubmit() {
    this.noteStoreUseCase.execute(this.storeRequest).then(() => {
      if (this.noteStoreUseCase.isSuccess) {
        this.modal = false
        this.getNotes()
      }
    })
  }

  onUpdateSubmit() {
    this.noteUpdateUseCase.execute(this.updateNoteId, this.storeRequest).then(() => {
      if (this.noteUpdateUseCase.isSuccess) {
        this.updateNoteId = null
        this.modal = false
        this.getNotes()
      }
    })
  }

  onEdit(note: NoteCollectionModel) {
    this.storeRequest.message = note.message
    this.updateNoteId = note.id
    this.modal = true
  }

  onDestroy(noteId: number) {
    this.noteService.destroy(noteId).then(() => {
      this.getNotes()
    })
  }
}
